import { ProfileReview } from '../../../../types';

export const PROFILE_ON_EDIT_REVIEW = 'PROFILE_ON_EDIT_REVIEW';
export const PROFILE_ON_REMOVE_REVIEW = 'PROFILE_ON_REMOVE_REVIEW';

export const onEditReview = (data: ProfileReview) => ({
  type: PROFILE_ON_EDIT_REVIEW,
  data,
});

export const onRemoveReview = (id: string) => ({
  type: PROFILE_ON_REMOVE_REVIEW,
  id,
});
